import React, {Component} from 'react';
import {withKeycloak} from '@react-keycloak/web';
import {Link} from 'react-router-dom';
import {connect} from 'react-redux';
import APIProjectConfiguration from '../utils/APIProjectConfiguration';
import FormProjectConfigDefault from '../partials/forms/FormProjectConfigDefault';
import FormProjectConfigUser from '../partials/forms/FormProjectConfigUser';

/**
 * Page: Update Global Project Configuration
 *
 */
class XProjectConfiguration extends Component {
    constructor(props) {
        super(props);
        this.state = {
            refreshDefaultConfigs: false,
        };
    }

    updateRefresh = (refresh) => {
        this.setState({
            refreshDefaultConfigs: refresh
        });
    };

    render() {
        const {
            user
        } = this.props;

        const {
            refreshDefaultConfigs
        } = this.state;

        const username = (user.name) ? ' ' + user.name : '';

        if (!user.is_sysop) {
            return (
                <>
                    <div className="content user">
                        <h1 className="page-title">
                            Xrathus Administration
                        </h1>
                        <p>
                            Sorry{username}, you do not have access to this area.
                        </p>
                    </div>
                </>
            )
        }

        return (
            <>
                <div className="content">
                    <h1 className="page-title">
                        Project Configuration
                    </h1>

                    <div className="panel no-padding">

                        <h3 className="header">Edit Global Project Configuration</h3>

                        <div className="row">
                            <div className="col col-xs-12">
                                <div className="form-container">
                                    <FormProjectConfigDefault onConfigUpdated={() => this.updateRefresh(true)}/>
                                    <br/>
                                </div>
                            </div>
                        </div>

                        <h3 className="header">Edit Personal Project Configuration for User</h3>

                        <div className="row">
                            <div className="col col-xs-12">
                                <div className="form-container">
                                    <FormProjectConfigUser/>
                                    <br/>
                                </div>
                            </div>
                        </div>

                        <div className="row">
                            <div className="col col-xs-12">
                                <div className="form-btns right mb-2 mr-2">
                                    <Link to="/x/admin"
                                          title="Back to Admin"
                                          className="btn btn-primary"
                                    >
                                        Back to Admin
                                    </Link>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <APIProjectConfiguration refresh={refreshDefaultConfigs} onResult={() => this.updateRefresh(false)}/>
            </>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        project_configuration_refresh: state.project_configuration_refresh,
        tokens: {
            token: state.tokens.token
        },
        user: state.user
    };
};

export default withKeycloak(
    connect(
        mapStateToProps
    )(XProjectConfiguration)
);
